import React from 'react';

import { ButtonProps, SelectListFilter } from '@sandtech-hub-monorepo/ui-kit';
import { useGeoPicker } from './picker';

export const StatePicker = ({
  countryCode,
  selected,
  handleOnSelect,
  triggerVariant,
  triggerClassName,
}: {
  countryCode?: string;
  selected?: string;
  handleOnSelect?: (item: { value: string; label: string }) => void;
  triggerVariant?: ButtonProps['variant'];
  triggerClassName?: string;
}) => {
  const { getStates } = useGeoPicker();

  return (
    <SelectListFilter
      items={countryCode ? getStates(countryCode) : undefined}
      defaultValue={selected}
      handleChange={handleOnSelect}
      variant={triggerVariant}
      triggerClassName={triggerClassName}
    />
  );
};
